import axiosInstance from "../axiosInstance";

// const base = `${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}`;
// const BASE_URL = `${base}/role_permissions`;

const BASE_URL = "/settings/role_permissions";

// Lấy danh sách vai trò
export const getRoles = () => {
  return axiosInstance.get(`${BASE_URL}/`);
};

// Lấy quyền của 1 vai trò
export const getRolePermissions = (roleId) => {
  return axiosInstance.get(`${BASE_URL}/${roleId}/permissions`);
};

// Cập nhật quyền cho 1 vai trò
export const updateRolePermissions = (roleId, permissions) => {
  return axiosInstance.put(`${BASE_URL}/${roleId}/permissions`, { permissions });
};

// Lấy data scope của 1 vai trò
export const getRoleDataScopes = (roleId) => {
  return axiosInstance.get(`${BASE_URL}/${roleId}/data-scopes`);
};

// Cập nhật data scope cho 1 vai trò
export const updateRoleDataScopes = (roleId, scopes) => {
  return axiosInstance.put(`${BASE_URL}/${roleId}/data-scopes`, { scopes });
};
